<template>
  <div class="idrwrap" @click="clickHander">
    <span v-if="start && end">
      {{ start | formatDatetime('yyyy-MM-dd') }}~{{ end | formatDatetime('yyyy-MM-dd') }}
    </span>
    <span v-else style="color: var(--g6)"> 请选择 </span>
  </div>
</template>

<script>
export default {
  name: 'input-date-range',
  props: {
    start: {
      default: '',
    },
    end: {
      default: '',
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    async clickHander() {
      let ret = await app.x3.picker.dateRange({
        startDate: this.start,
        endDate: this.end,
        config: {
          type: this.type,
        },
      });
      this.$emit('change', {
        startDate: app.tool.date.formatDatetime(ret.startDate, 'yyyy-MM-dd'),
        endDate: app.tool.date.formatDatetime(ret.endDate, 'yyyy-MM-dd'),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.idrwrap {
  width: 100%;
  height: calc(var(--w) * 36);
  line-height: calc(var(--w) * 36);
  text-align: center;
  border-radius: var(--radius-base);
  border: 1px solid var(--g4);
  cursor: pointer;
}
</style>